import React, { useEffect } from 'react';
import * as mobxReact from 'mobx-react';
import { useIntl } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../global/sub-window/common/common-close-sub-window-buttons';
import AttendeesLiveFormVM from './attendees-live-form.viewmodel';
import { AttendeesLiveFormBody } from './attendees-live-form-body/attendees-live-form-body';
import { DONE_TEXT } from '../../../../../constants/common-labels.constants';

interface IAttendeesLiveFormPresentation {
    vm: AttendeesLiveFormVM;
}

const AttendeesLiveFormPresentation = mobxReact.observer(({ vm }: IAttendeesLiveFormPresentation) => {
    const intl = useIntl();

    useEffect(() => {
        return () => {
            vm.joinedTabVM?.unsubscribe();
            vm.registrantsTabVM.attendeeDetailsVM.setClose();
        };
    }, []);

    return (
        <CommonPopupBodyFooterLayout
            body={<AttendeesLiveFormBody vm={vm} />}
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={intl.formatMessage(DONE_TEXT)}
                        modifier={['fat', 'confirm-safe']}
                    />
                </div>
            }
        />
    );
});

export { AttendeesLiveFormPresentation };
